const MAX_CONCURRENT_TRANSLATIONS = 5;

interface SlotWaiter {
  grant: () => void;
}

let availableSlots = MAX_CONCURRENT_TRANSLATIONS;
const waiters: SlotWaiter[] = [];

const releaseSlot = (): void => {
  const nextWaiter = waiters.shift();
  if (nextWaiter) {
    nextWaiter.grant();
  } else {
    availableSlots += 1;
  }
};

export const requestTranslationSlot = (onGranted: () => void): (() => void) => {
  let state: "waiting" | "held" | "done" = "waiting";
  const waiter: SlotWaiter = {
    grant: () => {
      state = "held";
      onGranted();
    },
  };

  const leave = (): void => {
    if (state === "held") {
      state = "done";
      releaseSlot();
    } else if (state === "waiting") {
      state = "done";
      waiters.splice(waiters.indexOf(waiter), 1);
    }
  };

  if (availableSlots > 0) {
    availableSlots -= 1;
    waiter.grant();
  } else {
    waiters.push(waiter);
  }
  return leave;
};

export const acquireTranslationSlot = async (): Promise<() => void> => {
  const holder: { leave?: () => void } = {};
  await new Promise<void>((resolve) => {
    holder.leave = requestTranslationSlot(resolve);
  });
  return holder.leave as () => void;
};
